import { Injectable } from '@angular/core';
import { GoogleAnalyticsService } from '@awin/shared/google-analytics';
import { BaseConfigService } from '@awin/shared';

@Injectable({ providedIn: 'root' })
export class AnalyticsEventSender {

  constructor(
    private readonly configService: BaseConfigService,
    private readonly googleAnalyticsService: GoogleAnalyticsService,
    private readonly logAnalyticsEvents: boolean = false,
  ) {
  }

  send(
    category: string,
    action: string,
    label: string = undefined,
  ): void {

    if (this.configService.isLive) {
      // To checked how to also send the action
      this.googleAnalyticsService.sendEvent({eventCategory: category, eventLabel: label});
    }

    if (this.logAnalyticsEvents) {
      console.debug('Analytics event:', [category, action, label]);
    }
  }

}
